import SubmissionsCard from "./SubmissionsCard";

export default SubmissionsCard;
